import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex } from '@woovi/ui';
import { maskMoney } from '@woovi/utils';

import type { PaymentLinkValueFirstInstallment_charge$key } from './__generated__/PaymentLinkValueFirstInstallment_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkValueFirstInstallmentProps = {
  charge: PaymentLinkValueFirstInstallment_charge$key;
};

const PaymentLinkValueFirstInstallment = (
  props: PaymentLinkValueFirstInstallmentProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentLinkValueFirstInstallment_charge$key>(
    graphql`
      fragment PaymentLinkValueFirstInstallment_charge on Charge {
        id
        paymentMethods {
          ... on PaymentMethodPix {
            value
            valueWithDiscount
          }
        }
        customer {
          name
        }
        company {
          nameFriendly
        }
      }
    `,
    props.charge,
  );

  const valueWithDiscount = maskMoney(
    charge.paymentMethods[0].valueWithDiscount / 100,
  );

  return (
    <BoxFlex sx={{ justifyContent: 'center' }}>
      <Typography
        sx={{ fontSize: 24, fontWeight: 'bold', textAlign: 'center' }}
      >
        {charge.customer
          ? t(
              '{{customerName}}, pay entrance from {{valueWithDiscount}} to {{companyName}} via Pix',
              {
                customerName: charge.customer.name,
                valueWithDiscount,
                companyName: charge.company.nameFriendly,
              },
            )
          : t(
              'Pay the entrance of {{valueWithDiscount}}to {{companyName}} via Pix',
              {
                valueWithDiscount,
                companyName: charge.company.nameFriendly,
              },
            )}
      </Typography>
    </BoxFlex>
  );
};

export default PaymentLinkValueFirstInstallment;
